import { JobLocation } from "./onboardingListTypes";

interface LocationSuggestion {
	urn: string;
	title: string;
}

type FetchSuggestions = (
	args: { type: string; keyword: string },
	preferCacheValue?: boolean
) => {
	unwrap: () => Promise<{ suggestions: LocationSuggestion[] }>;
};

/**
 * Turns the free-text ICP location ("Germany", "DACH, Austria") into the
 * `{ id, name }` shape the JOBS source needs, by resolving its first part
 * through the same location suggestion endpoint the picker's own field uses.
 * Returns `null` when nothing resolves — the user then picks a location
 * manually (JOBS cannot run without one).
 *
 * The suggestion is read with `preferCacheValue`: the same lookup is prewarmed
 * on the chat step, and a geo suggestion for a fixed keyword does not change
 * within a session.
 */
export const resolveIcpLocation = async (
	location: string | null | undefined,
	fetchSuggestions: FetchSuggestions
): Promise<JobLocation | null> => {
	const keyword = (location ?? "").split(/[,/&]/)[0].trim();

	if (keyword.length < 2) {
		return null;
	}

	try {
		const { suggestions } = await fetchSuggestions({ type: "location", keyword }, true).unwrap();
		const [first] = suggestions;

		return first ? { id: String(first.urn), name: first.title } : null;
	} catch (err) {
		console.error(err);

		return null;
	}
};
